import {
  getDateMillisFromTicks,
  getMomentFromMillis,
  isMinDate,
  getMoment,
  getMomentFromISOString,
} from '../../../utils/DateTimeUtils';

export function getMomentForEditor(value: any, justDate = false) {
  let ticks: number = 0;
  if (value?.DateTicks) {
    ticks = value?.DateTicks;
    if (ticks) return getMomentFromMillis(getDateMillisFromTicks(ticks), justDate);
  } else {
    const moment = getMoment()(value);
    if (moment.isValid() && !isMinDate(value)) {
      // return date only if it is not C# min date
      return getMomentFromISOString(value, justDate);
    }
  }

  return null;
}
